"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusRingStyles = void 0;
var core_1 = require("@emotion/core");
var theme_1 = require("../theme");
exports.FocusRingStyles = (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &[data-focus-visible] {\n    outline: ", " solid ", ";\n    outline-offset: ", ";\n  }\n"], ["\n  &[data-focus-visible] {\n    outline: ", " solid ", ";\n    outline-offset: ", ";\n  }\n"])), theme_1.theme.borderWidths.thick, theme_1.theme.colors.borderPrimary, theme_1.theme.space.space2);
var templateObject_1;
//# sourceMappingURL=focusRingStyles.js.map